<div (click)="onClick()" class="btn btn-primary">
  <img width="{{ iconWidth }}" *ngIf="icon" src="{{ icon }}" alt="" />
  <span>{{ buttonText | translate }}</span>
</div>
